import {
    ChevronDown,
    Select,
    SelectContent,
    SelectIcon,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@jog/react-components"
import { Properties } from "@jog/types"

export const Sorting = ({
    onChange,
    sortfields,
}: {
    sortfields: Properties["sortfields"]
    onChange: (v: string) => void
}) => {
    if (!sortfields) return <></>
    return (
        <Select
            value={sortfields?.find((i) => i.isselected)?.url || sortfields[0]?.url}
            onValueChange={(value) => onChange(value)}>
            <SelectTrigger
                aria-label="Sorting"
                className="relative w-full appearance-none border border-gray-dark px-1.75 py-2 text-center text-xs font-bold uppercase outline-0 lg:mx-2 lg:w-auto lg:min-w-[250px]">
                <SelectValue>
                    {sortfields?.find((i) => i.isselected)?.displaytitle || sortfields[0]?.displaytitle}
                </SelectValue>
                <SelectIcon asChild>
                    <ChevronDown
                        className="absolute right-3 top-1/2 h-5 w-5 shrink-0 -translate-y-1/2 text-black"
                        aria-hidden="true"
                        strokeWidth={1}
                    />
                </SelectIcon>
            </SelectTrigger>
            <SelectContent
                position="popper"
                className="relative z-50 overflow-hidden border border-gray-medium bg-white text-black data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1">
                {sortfields.map((i) => (
                    <SelectItem
                        className="relative flex w-full cursor-pointer select-none items-center py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-gray-bg"
                        key={i.url}
                        value={`${i.url}`}>
                        {i.displaytitle}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
